import { Directive, Input, OnChanges, SimpleChanges } from "@angular/core";
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from "@angular/forms";
import { BaseValidator } from "./base.directive";
import { ValidationTypes } from "./validator-const.model";

@Directive({
    selector: '[cpqCustomValidation]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: CpqCustomValidator, multi: true }
    ],
    standalone: false
})
export class CpqCustomValidator extends BaseValidator implements Validator, OnChanges {
    @Input('cpqCustomValidation')cpqCustomValidation: string;
    private onChange: () => void;

    ngOnChanges(changes: SimpleChanges): void {
        if(this.onChange) {
            this.onChange();
        }
    }

    validate(control: AbstractControl): ValidationErrors {
        return this.cpqCustomValidation ? this.createMessage(ValidationTypes.cpqCustomValidation, this.cpqCustomValidation) : null;
    }

    registerOnValidatorChange(fn: () => void): void { this.onChange = fn };

}